import { LanguageCodes } from '..';
import { DEFAULT_LANGUAGE } from '../context/Translation.context';

export let language = {};

const substituteVariables = (text, variables = {}) => {
	return text.replace(/\{\{(.*?)\}\}/g, (_, varName) => {
		const trimmedVarName = varName.trim();
		return String(variables[trimmedVarName] ?? '');
	});
};

const getNestedValue = (obj, keyPath) => {
	const keys = keyPath.split('.');
	let current = obj;

	for (const key of keys) {
		if (!current || typeof current !== 'object' || !(key in current)) {
			return null;
		}
		current = current[key];
	}

	return typeof current === 'string' ? current : null;
};

export const getTranslation = (languagePack, currentLanguage) => {
	// Cache the language pack globally
	language = languagePack;

	return (key, variables = {}) => {
		// Try to get translation from current language
		const translation = getNestedValue(languagePack, key);

		if (translation) {
			return substituteVariables(translation, variables);
		}

		// Fallback to default language if key not found
		const fallbackTranslation = getNestedValue(
			LanguageCodes[DEFAULT_LANGUAGE],
			key
		);

		if (fallbackTranslation) {
			if (currentLanguage && currentLanguage !== DEFAULT_LANGUAGE) {
				console.warn(
					`Translation key "${key}" not found for language "${currentLanguage}", using ${DEFAULT_LANGUAGE} fallback`
				);
			}
			return substituteVariables(fallbackTranslation, variables);
		}

		// Final fallback: return the key itself
		console.warn(
			`Translation key "${key}" not found for language "${currentLanguage || 'unknown'}"`
		);
		return key;
	};
};
